import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const getFormDefaults = () => {
  return {
    plantingTime: '',
    plantingMethod: 0,
    primaryGoal: 0,
    secondaryGoal: 1,
    selectedCrops: [],
    mixName: 'My New Mix',
    mixUnits: '%',
    zip: '',
    acres: 15,
    packagingOption: '',
    inoculantOption: 0
  }
}
const getTotalDefaults = () => {
  return {
    lbsPerAcre: 0,
    seedCostPerAcre: 0,
    inoculantCostPerAcre: 0,
    blendingFeePerAcre: 0,
    discount: 0
  }
}

const getStoreDomain = () => {
  let storeDomain = 'https://www.millbornseeds.com'
  if (window.location.host.indexOf('dev') > -1) {
    storeDomain = 'https://dev.millbornseeds.com'
  } else if (window.location.host.indexOf('localhost') > -1) {
    storeDomain = 'https://millbornseeds.test'
  }
  return storeDomain
}

const cropScoreLabels = [
  {
    1: 'None',
    2: 'Poor',
    3: 'Fair',
    4: 'Good',
    5: 'Excellent'
  },
  {
    1: 'Poor',
    2: 'Low',
    3: 'Fair',
    4: 'Good',
    5: 'Excellent'
  },
  {
    1: 'Very Low',
    2: 'Low',
    3: 'Medium',
    4: 'High',
    5: 'Very High'
  }
]

export default new Vuex.Store({
  state: {
    prevRoute: null,
    availableCrops: [],
    formData: getFormDefaults(),
    totals: getTotalDefaults(),
    storeDomain: getStoreDomain(),
    mixTargets: [100, 65, 120, 130],
    plantingMethods: [
      'Drilling',
      'Overseeding',
      'Broadcasting',
      'Aerial Applying'
    ],
    cropFacets: [
      { name: 'Nitrogen fixation', labels: cropScoreLabels[0] },
      { name: 'Grazing', labels: cropScoreLabels[1] },
      { name: 'Reduce soil compaction', labels: cropScoreLabels[1] },
      { name: 'Salinity tolerance', labels: cropScoreLabels[1] },
      { name: 'C:N ratio', labels: cropScoreLabels[2] },
      { name: 'Nutrient scavenging', labels: cropScoreLabels[1] }
    ],
    showMixInstructions: true
  },
  mutations: {
    reset (state) {
      state.formData = getFormDefaults()
      state.totals = getTotalDefaults()
    },
    showMixInstructions (state, value) {
      state.showMixInstructions = value
    },
    updateAvailableCrops (state, crops) {
      state.availableCrops = crops
    },
    updatePlantingTime (state, value) {
      state.formData.plantingTime = value
    },
    updatePrimaryGoal (state, value) {
      state.formData.primaryGoal = value
    },
    updateSecondaryGoal (state, value) {
      state.formData.secondaryGoal = value
    },
    addMixComponent (state, obj) {
      // remove when we're updating an amount
      state.formData.selectedCrops.forEach((entry, index) => {
        if (obj.crop === entry.crop) {
          state.formData.selectedCrops.splice(index, 1)
        }
      })
      // add to selections
      state.formData.selectedCrops.push(obj)
    },
    updateMixName (state, value) {
      state.formData.mixName = value
    },
    updateMixUnits (state, value) {
      state.formData.mixUnits = value
    },
    updateZip (state, value) {
      state.formData.zip = value
    },
    updatePlantingMethod (state, value) {
      state.formData.plantingMethod = value
    },
    updateAcres (state, value) {
      state.formData.acres = value
    },
    updatePackagingOption (state, value) {
      state.formData.packagingOption = value
    },
    updateInoculantOption (state, value) {
      state.formData.inoculantOption = value
    },
    updateTotalLbs (state, value) {
      state.totals.lbsPerAcre = value
    },
    updateComponentCost (state, value) {
      state.totals.seedCostPerAcre = value
    },
    updateInoculantCost (state, value) {
      state.totals.inoculantCostPerAcre = value
    },
    updateBlendingFee (state, value) {
      state.totals.blendingFeePerAcre = value
    },
    updateDiscountAmt (state, value) {
      state.totals.discount = value
    }
  }
})
